import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import DepositHistoryPage from "components/pages/DepositHistoryPage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureDepositsHistory(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });
    
    return <DepositHistoryPage />
}